__webpack_require__.p = "/bo/assets/";